enum LocaleLanguages {
  English = "en",
  Russian = "ru",
}

export default LocaleLanguages